import { HeaderContainer, isLoggedIn } from "@shapr3d/frontend-lib";

import useAccount from "../../../hooks/useAccount";
import { LoginButton } from "../components/LoginButton/LoginButton";
import { LogoHeader } from "../components/LogoHeader/LogoHeader";
import { MenuHeader } from "../components/MenuHeader/MenuHeader";
import { StartModelingButton } from "../components/StartModelingButton/StartModelingButton";

import style from "./GenericHeader.module.css";

export const GenericHeader = () => {
  const { data: accountData, isPending: isAccountPending } = useAccount();

  return (
    <HeaderContainer>
      <LogoHeader />

      <div className={style.buttonContainer}>
        <StartModelingButton />
        {isLoggedIn() && !isAccountPending && <MenuHeader accountData={accountData} />}
        {!isLoggedIn() && (
          <>
            <div className={style.separator} />
            <LoginButton />
          </>
        )}
      </div>
    </HeaderContainer>
  );
};
